export const spaceName = 'odDeals';

export interface DealsSettings {
  viewMode: 'gridView' | 'listView';
  selectedIds: Number[];
  currentPageInfo: {
    data: any;
    params: {
      currentPage: Number;
      pageSize: Number;
      total: Number;
    };
  };
  searchItem: string | false;
}

export default {
  viewMode: 'gridView',
  selectedIds: [],
  currentPageInfo: {
    data: [],
    params: {
      currentPage: 1,
      pageSize: 12,
      total: 0,
    },
  },
  searchItem: false,
} as DealsSettings;

export const getListViewColumns = (props: any) => {
  const {
    helper: { tx },
    actionButton,
  } = props;

  return [
    {
      title: tx('Management_Deal.deal_name'),
      dataIndex: 'name',
      key: 'name',
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
      ellipsis: true,
      width: 200,
      fixed: 'left',
    },
    {
      title: tx('Global.valid_period'),
      dataIndex: 'dealDate',
      key: 'dealDate',
      width: 150,
      render: (x: any, record: any) =>
        record.issueDate && record.expiryDate ? `${record.issueDate} - ${record.expiryDate}` : '',
    },
    {
      title: tx('Global.created_at'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      // sorter: (a: any, b: any) => a.createdAt.localeCompare(b.createdAt),
      ellipsis: true,
      width: 150,
    },
    {
      title: tx('Global.updated_at'),
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      // sorter: (a: any, b: any) => a.updatedAt.localeCompare(b.updatedAt),
      ellipsis: true,
      width: 150,
    },
    {
      title: tx('Global.recommend'),
      dataIndex: 'isRecommended',
      key: 'isRecommended',
      width: 150,
      // filters: [
      //   {
      //     text: tx('t_true'),
      //     value: 'true',
      //   },
      //   {
      //     text: tx('t_false'),
      //     value: 'false',
      //   },
      // ],
      // onFilter: (value: any, record: any) => [record.isRecommended].indexOf(value) >= 0,
      // sorter: (a: any, b: any) => a.isRecommended.localeCompare(b.isRecommended),
    },
    actionButton,
  ];
};
